
export const ApiUrl = {
    HomePageUrl: `/apim/rkgwebsite`,
    ContactUrl: `/apim/rkgwebsite/contactform`,
    CareerPostUrl: `/apim/rkgwebsite/careerform`,
    DocumentPostUrl: `/apim/document/preupload`



}